var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-position",class:{
    'section-default': _vm.defaultClass,
    'default-gup': _vm.defaultGup,
    'section-overflow-reverts': _vm.isOverflowReverts
  }},[_c('base-background',[_vm._t("section-background")],2),_c('div',{staticClass:"content"},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }